import { Box, Stack, Typography } from "@mui/material";

export const Header = ({
  title,
  subtitle,
  icon,
}: {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  icon?: React.ReactNode;
}) => {
  return (
    <Stack direction="row" sx={{ gap: 2, alignItems: "center", mb: 4 }}>
      {icon}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="h2">
          {title}
        </Typography>
        <Typography variant="body1" sx={{ mt: 0.75, color: "text.secondary" }}>
          {subtitle}
        </Typography>
      </Box>
    </Stack>
  );
};
